import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { SearchBaseDto } from './search-base-dto.type';

const SearchBaseDtoPaginationResponse = t.type(
  {
    pageIndex: t.number,
    pageSize: t.number,
    orderBy: nullable(t.string),
    orderIsAscending: t.boolean,
    items: nullable(t.array(SearchBaseDto)),
    totalCount: t.number,
  },
  'SearchBaseDtoPaginationResponse',
);

type SearchBaseDtoPaginationResponse = t.TypeOf<
  typeof SearchBaseDtoPaginationResponse
>;
export { SearchBaseDtoPaginationResponse };
